import { useQuery } from '@tanstack/react-query';

import { get } from '@helpers/common/axios.helper';

import {
  API_COMMON_PERSONAL_KPI,
  API_COMMON_STATS,
  API_COMMON_TAGS_BADGES,
} from '@constants/vaults/api.constants';

import {
  PersonalKpiDto,
  StatsDto,
  TagsBadgesDto,
} from '@dto/vaults/common.dto';

export const getTagsBadges = (chainIds: number[]) =>
  get<TagsBadgesDto>(API_COMMON_TAGS_BADGES, { chainIds });

export const getStats = (chainIds: number[], account?: string) =>
  get<StatsDto>(API_COMMON_STATS, { chainIds, account });

export const getPersonalKpi = (account?: string) =>
  get<PersonalKpiDto>(API_COMMON_PERSONAL_KPI, { account });

export const useGetTagsBadges = (chainIds: number[]) =>
  useQuery<TagsBadgesDto>({
    queryKey: [API_COMMON_TAGS_BADGES, chainIds],
    queryFn: () => getTagsBadges(chainIds),
    retry: false,
  });

export const useGetStats = (chainIds: number[], account?: string) =>
  useQuery<StatsDto>({
    queryKey: [API_COMMON_STATS, chainIds, account],
    queryFn: () => getStats(chainIds, account),
    retry: false,
  });

export const useGetPersonalKpi = (account?: string) =>
  useQuery<PersonalKpiDto>({
    queryKey: [API_COMMON_PERSONAL_KPI, account],
    queryFn: () => getPersonalKpi(account),
    retry: false,
    enabled: !!account,
  });
